/**
 * Enum for States inactive/active
 */
export class State {
    public static active = 'active';
    public static inactive = 'inactive';
    public static in = 'in';
}